<ion-toolbar class="">
  <ion-list>
    <!-- TODO move to 'my company' page -->
    <!-- <ion-menu-toggle autoHide="false">
      <lib-lang-select></lib-lang-select>
    </ion-menu-toggle> -->

    <ion-menu-toggle autoHide="false">
      <ion-item
        button
        routerLink="/help"
        routerLinkActive="active"
        routerDirection="root"
        detail="false"
      >
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/help_24dp.svg"
          slot="start"
        ></ion-icon>
        <ion-label>{{ 'general.nav_bar.help' | translate }}</ion-label>
      </ion-item>
    </ion-menu-toggle>
    <ion-menu-toggle autoHide="false">
      <ion-item
        button
        routerLink="/support"
        routerLinkActive="active"
        routerDirection="root"
        detail="false"
      >
        <ion-icon
          aria-hidden="true"
          src="../assets/material-symbols/support_agent_24dp.svg"
          slot="start"
        ></ion-icon>
        <ion-label>{{ 'general.nav_bar.support_contact' | translate }}</ion-label>
      </ion-item>
    </ion-menu-toggle>
  </ion-list>
</ion-toolbar>
